import noop from 'lodash/noop';
import { bool, func, number, string } from 'prop-types';
import { Component, Fragment } from 'react';

import api from 'atg/api/API';
import Button from 'shared/components/button/Button';
import CloseButton from 'shared/components/button/CloseButton';
import HelpButton from 'shared/components/button/HelpButton';
import CheckboxInput from 'shared/components/input/CheckboxInput';
import TextInput from 'shared/components/input/TextInput';
import { atgBetType } from 'shared/proptypes';
import { getText } from 'shared/utils/Text';

export default class TemplateDialog extends Component {
  static propTypes = {
    closeHandler: func.isRequired,
    onSaved: func,
    id: number,
    name: string,
    betType: atgBetType.isRequired,
    reductionsEnabled: bool,
    marksEnabled: bool,
  };

  static defaultProps = {
    reductionsEnabled: true,
    marksEnabled: true,
    onSaved: noop,
  };

  state = {};

  componentDidMount() {
    const name = this.props.name || getText('dialog-bet-template-default-name');

    this.setState({ name });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      reductionsEnabled: prevState.hasOwnProperty('reductionsEnabled')
        ? prevState.reductionsEnabled
        : nextProps.reductionsEnabled,
      marksEnabled: prevState.hasOwnProperty('marksEnabled')
        ? prevState.marksEnabled
        : nextProps.marksEnabled,
    };
  }

  onNameChange = name => {
    this.setState({ name });
  };

  onReductionEnabledChange = () => {
    this.setState({
      reductionsEnabled: !this.state.reductionsEnabled,
    });
  };

  onMarksEnabledChange = () => {
    this.setState({
      marksEnabled: !this.state.marksEnabled,
    });
  };

  onSaveClick = () => {
    const { id, closeHandler, onSaved } = this.props;
    const { name, reductionsEnabled, marksEnabled } = this.state;

    api.saveTemplate(
      id,
      name || getText('dialog-bet-template-default-name'),
      reductionsEnabled,
      marksEnabled,
      () => {
        onSaved();
        closeHandler();
      },
    );
  };

  render() {
    const { closeHandler, id, betType } = this.props;
    const { name, reductionsEnabled, marksEnabled } = this.state;

    return (
      <Fragment>
        <h1 className="dialog-title dialog-title--with-help">
          {getText(`dialog-bet-template-title_${id ? 'edit' : 'create'}`)}
          <HelpButton
            header={getText('dialog-bet-template-help-header')}
            body={getText('dialog-bet-template-help-body')}
          />
        </h1>
        <CloseButton onClick={closeHandler} />

        <hr />

        <div className="fgrid fgrid--dialog-form">
          <div className="fgrid-cell fgrid-cell-label">
            {getText('dialog-bet-template-name')}
          </div>
          <div className="fgrid-cell fgrid-cell-field bet-template-name-field">
            <span className="template-bet-type">{betType}-</span>
            <TextInput
              className="template-name w100p"
              value={name}
              onChange={this.onNameChange}
              autoComplete="off"
            />
          </div>
        </div>

        <div className="fgrid fgrid--dialog-form">
          <div className="fgrid-cell fgrid-cell-label">
            {getText('dialog-bet-template-reductions')}
          </div>
          <div className="fgrid-cell fgrid-cell-field">
            <CheckboxInput
              checked={reductionsEnabled}
              onChange={this.onReductionEnabledChange}
              colorFill
            />
          </div>
        </div>

        <div className="fgrid fgrid--dialog-form">
          <div className="fgrid-cell fgrid-cell-label">
            {getText('dialog-bet-template-marks')}
          </div>
          <div className="fgrid-cell fgrid-cell-field">
            <CheckboxInput
              checked={marksEnabled}
              onChange={this.onMarksEnabledChange}
              colorFill
            />
          </div>
        </div>

        <hr />

        <ul className="button-list fgrid fgrid--1of2">
          <li className="fgrid-cell positive">
            <Button onClick={this.onSaveClick}>
              <span className="sprite dialog-confirm" />
              <span className="label">{getText('dialog-confirm-confirm')}</span>
            </Button>
          </li>
          <li className="fgrid-cell negative">
            <Button onClick={closeHandler}>
              <span className="sprite dialog-cancel" />
              <span className="label">{getText('dialog-confirm-cancel')}</span>
            </Button>
          </li>
        </ul>
      </Fragment>
    );
  }
}
